import React, { useCallback } from "react";
import { Button } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";

export const useLogoutRoutine = () => {
  const { logout } = useAuth0();

  return useCallback(() => {
    const returnTo = window.location.origin;
    logout({ returnTo });
  }, [logout]);
};

const LogoutButton = () => {
  const { t } = useTranslation();

  const logoutRoutine = useLogoutRoutine();

  return <Button color="inherit" onClick={() => logoutRoutine()}>{t("AUTH.LOGOUT")}</Button>;
};

export default LogoutButton;
